import React from 'react'
import { Text, View } from 'dripsy'

type Props = {
  children: React.ReactNode
  fontSize?: number[] | number
  right?: boolean
} & React.ComponentProps<typeof Text>

export default function InputLabel(props: Props) {
  const { sx = {}, children, fontSize = 2, right = false } = props

  return (
    <View
      sx={{
        bg: 'muted',
        justifyContent: 'center',
      }}
    >
      <Text
        sx={{
          // height: '100%',
          p: 2,
          lineHeight: fontSize,
          fontSize,
          color: 'muted6',
          borderLeftWidth: right ? 1 : 0,
          borderRightWidth: right ? 0 : 1,
          borderColor: 'muted5',
          ...sx,
        }}
      >
        {children}
      </Text>
    </View>
  )
}
